import Navbar from '@/components/feature/Navbar';
import ReviewHero from './components/ReviewHero';
import ReviewStats from './components/ReviewStats';
import ReviewGrid from './components/ReviewGrid';
import ReviewCta from './components/ReviewCta';
import ContactFooter from '@/pages/home/components/ContactFooter';

export default function ReviewPage() {
  return (
    <div className="min-h-screen w-full">
      <Navbar />
      <ReviewHero />
      <ReviewStats />
      <ReviewGrid />
      <ReviewCta />
      <ContactFooter />
    </div>
  );
}
